module.exports = __webpack_public_path__ + "media/images/new-plan-79c4734e010b44dc8ff0cd0db00cd1d1.svg";